import React from "react";
import Modal from "react-bootstrap/Modal";
// import "./Modal.css"; // optional, for styling

const CustomModal = ({ title, isOpen, onClose, children, size = "auto" }) => {
  // if (!isOpen) return null;

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      size={size}
      centered
    >
      <Modal.Header closeButton>
        {title && (
          <Modal.Title>
            <h4>{title}</h4>
          </Modal.Title>
        )}
      </Modal.Header>
      <Modal.Body> {children}</Modal.Body>
      {/* <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Close
          </Button>
          <Button variant="primary" onClick={closeModal}>
            Save Changes
          </Button>
        </Modal.Footer> */}
    </Modal>
    // <div
    //   className="modal fade"
    //   id="staticBackdrop"
    //   data-bs-backdrop="static"
    //   data-bs-keyboard="false"
    //   tabIndex="-1"
    //   aria-labelledby="staticBackdropLabel"
    // >
    //   <div className="modal-dialog">
    //     <div className="modal-content">
    //       <div className="modal-header">

    //         <button
    //           type="button"
    //           className="btn-close"
    //           data-bs-dismiss="modal"
    //           aria-label="Close"
    //         ></button>
    //       </div>
    //       <div className="modal-body">{children}</div>

    //     </div>
    //   </div>
    // </div>
    // <div classNameName="modal-overlay" onClick={onClose}>
    //   <div
    //     classNameName="modal-content"
    //     data-keyboard="false"
    //     data-backdrop="static"
    //     onClick={(e) => e.stopPropagation()}
    //   >
    //     <button classNameName="modal-close" onClick={onClose}>
    //       &times;
    //     </button>
    //     {children}
    //   </div>
    // </div>
  );
};

export default CustomModal;
